import { 
	createSlice,
	createSelector,
	createAsyncThunk,
	createEntityAdapter
} from '@reduxjs/toolkit'

const slice = createSlice({
	name: 'resourceLibrary',
	initialState : {
		show:false,
		//Exercise/food
		resourceType:null,
		tgtResourceType:null,
		tgtResourceId:null,
		insertPosition:0,
		heading:0,
		superset:0,
		replace:{},
		selectedItems:[]
	},
	reducers : {
		update:(state,action)=>{
			Object.entries(action.payload).forEach(([k,v])=>{
				state[k] = v
			})
		}
	},
	extraReducers : {}
})

export const {update} = slice.actions

export default slice.reducer